import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import Card from '../common/Card'
import { FC, ReactNode } from 'react'

const classNamesByType = {
  error: {
    card: 'text-fuchsia-800',
    title: 'bg-fuchsia-800/10',
    button: 'btn-fuchsia-outlined',
  },
  info: {
    card: 'text-secondary-700',
    title: 'bg-secondary-700/10',
    button: 'btn-secondary-outlined',
  },
}

type AlertProps = {
  type: 'info' | 'error'
  Icon?: FC
  title: string
  reviewLink?: string
  children: ReactNode
  buttonText?: string
  reviewLinkText?: string
  onClick?: () => void
}

const Alert = ({
  type = 'info',
  Icon,
  title,
  reviewLink,
  reviewLinkText = 'Review',
  children,
  buttonText = 'Review',
  onClick,
}: AlertProps) => {
  const buttonClassName = classNames('btn-small', classNamesByType[type]?.button)

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onSubmit',
  })
  return (
    <Card
      TitleIcon={Icon}
      title={title}
      className={classNames('lg:!max-w-[322px] m-6 [&_svg]:fill-current [&_svg]:min-w-4', classNamesByType[type]?.card)}
      titleClassName={classNamesByType[type]?.title}
      actions={
        <>
          {reviewLink && (
            <Link to={reviewLink} className={buttonClassName}>
              {reviewLinkText}
            </Link>
          )}
          {onClick && (
            <form onSubmit={handleSubmit(onClick)}>
              <button className={buttonClassName} type={'submit'} disabled={isSubmitting}>
                {buttonText}
              </button>
            </form>
          )}
        </>
      }
    >
      <div className="typography-body-l text-neutral-600">{children}</div>
    </Card>
  )
}

export default Alert
